import React from 'react'
import ReactDOM from 'react-dom/client'

import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'

import { App } from './App'

import type { AddToCartEshopAfterParams as AddToCartEshopAfterParameters, AddToCartEshopParams as AddToCartEshopParameters } from '#/global/component/Product/AddToCart/Eshop'
import type { AddToCartRentalAfterParams as AddToCartRentalAfterParameters, AddToCartRentalParams as AddToCartRentalParameters } from '#/global/component/Product/AddToCart/Rental'

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: Infinity, // Vypnutí re-fetch při procházení. Re-fetch až při F5.
            refetchOnWindowFocus: false,
            retry: false,
            gcTime: Infinity, // Garbage collector - off
        },
    },
})

// localhost buttons for dev
const development = () => {
    // open eshop
    const openEshop = (code: string, quantitySales = 2) => {
        window.dispatchEvent(new CustomEvent<AddToCartEshopAfterParameters>('ES_ADD_TO_CART_ESHOP_AFTER', {
            detail: {
                code,
                product: undefined!, // map to mocks
                quantitySales,
                unitSales: 'xxx',
                eventInvoker: 'detail',
                isSuccess: true,
            },
        }))
    }

    // open rental
    const openRental = (withGuarantee: boolean, typeOfRental: AddToCartRentalParameters['typeOfRental'] = 'Default') => {
        const dateFrom = new Date()
        const dateTo = new Date()
        dateTo.setDate(dateTo.getDate() + 5)

        window.dispatchEvent(new CustomEvent<AddToCartRentalAfterParameters>('ES_ADD_TO_CART_RENTAL_AFTER', {
            detail: {
                unionCode: 'PSK0164|PP00021',
                quantity: 1,
                quantitySales: 1,
                dateFrom,
                dateTo: typeOfRental === 'HalfDay' ? dateFrom : dateTo,
                eventInvoker: 'detail',
                withGuarantee,
                isSuccess: true,
                recordId: -1,
                typeOfRental,
                product: undefined!, // map to mocks
            },
        }))
    }

    // Mocking add to cart for ProductCompact with 2s delay and 50% success rate
    window.addEventListener('ES_ADD_TO_CART_ESHOP', event => void resolveDelay('ES_ADD_TO_CART_ESHOP_AFTER', event))
    window.addEventListener('ES_ADD_TO_CART_RENTAL', event => void resolveDelay('ES_ADD_TO_CART_RENTAL_AFTER', event))

    const resolveDelay = async (eventName: string, event?: CustomEvent<AddToCartEshopParameters | AddToCartRentalParameters>) => {
        const detail = event?.detail
        // wait 2s
        await new Promise(resolve => setTimeout(resolve, 2000))
        // random true or false
        const isSuccess = Math.random() > 0.5
        window.dispatchEvent(new CustomEvent(eventName, { detail: { ...detail, isSuccess } }))
    }

    // Dev buttons
    // !todo map to mocks. Because of the missing product in the event
    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', maxWidth: '160px' }}>
            <button className="dek-button-green" onClick={() => openEshop('1010151880', 7.5)} role="button" type="button">ESHOP</button>
            <button className="dek-button-green" onClick={() => openEshop('3010488120', 6.25)} role="button" type="button">ESHOP - season a)</button>
            <button className="dek-button-green" onClick={() => openEshop('1020499145', 20)} role="button" type="button">ESHOP - season b)</button>
            <button className="dek-button-blue" onClick={() => openRental(true)} role="button" type="button">RENTAL - s garancí</button>
            <button className="dek-button-blue" onClick={() => openRental(false)} role="button" type="button">RENTAL - bez garance</button>
            <button className="dek-button-blue" onClick={() => openRental(true, 'HalfDay')} role="button" type="button">RENTAL - s garance - 4 hodiny</button>
        </div>
    )
}

// for dev end

ReactDOM.createRoot(document.querySelector('#r-a-modal-cross-selling')!).render(
    <React.StrictMode>
        {import.meta.env.DEV && development()}
        <QueryClientProvider client={queryClient}>
            <App />
            <ReactQueryDevtools />
        </QueryClientProvider>
    </React.StrictMode>,
)
